import React, { useId } from 'react';
import './ui.css';

export interface FieldProps {
  label: React.ReactNode;
  hint?: React.ReactNode;
  /** Shown inline under the control — never window.alert(). */
  error?: React.ReactNode;
  /** Render prop receiving the id and aria props the control must carry. */
  children: (control: { id: string; 'aria-invalid'?: true; 'aria-describedby'?: string }) => React.ReactNode;
  className?: string;
}

export function Field({ label, hint, error, children, className }: FieldProps) {
  const id = useId();
  const noteId = `${id}-note`;
  return (
    <div className={['ui-field', className].filter(Boolean).join(' ')}>
      <label className="ui-field__label" htmlFor={id}>{label}</label>
      {children({
        id,
        'aria-invalid': error ? true : undefined,
        'aria-describedby': error || hint ? noteId : undefined,
      })}
      {error ? (
        <span id={noteId} className="ui-field__error" role="alert">{error}</span>
      ) : hint ? (
        <span id={noteId} className="ui-field__hint">{hint}</span>
      ) : null}
    </div>
  );
}

export const Input = React.forwardRef<HTMLInputElement, React.InputHTMLAttributes<HTMLInputElement>>(
  function Input({ className, ...rest }, ref) {
    return <input ref={ref} className={['ui-input', className].filter(Boolean).join(' ')} {...rest} />;
  },
);
